import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import LabelValue from 'components/LabelValue';
import _isEmpty from 'lodash/isEmpty';
import _isNumber from 'lodash/isNumber';
import useDateLocale from 'components/useDateLocale';

const styles = theme => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    marginTop: 10,
    flexWrap: 'wrap',
  },
  divider: {
    borderRight: '1px solid #E9ECED',
    margin: '0 18px',
    height: 13,
    [theme.breakpoints.down('xs')]: {
      margin: '0 12px',
    },
  },
  label: {
    height: '100%',
  },
});

function DateAndOrgs(props) {
  const { data, classes } = props;
  const {
    fields: { publicationDate = '', organization = '' },
  } = data;
  const dateFormatFilter = useDateLocale();
  return (
    <Grid item xs={12} className={classes.root}>
      {(_isNumber(publicationDate) || !_isEmpty(publicationDate)) && (
        <>
          <Typography variant="overline" color="textPrimary">
            {format(parseISO(publicationDate), 'MMM dd, yyyy', {
              locale: dateFormatFilter,
            })}
          </Typography>
          {!_isEmpty(organization) && organization[0].name !== null && (
            <div className={classes.divider} />
          )}
        </>
      )}
      {!_isEmpty(organization) && (
        <div className={classes.label}>
          <LabelValue value={organization} type="organizations" overline />
        </div>
      )}
    </Grid>
  );
}

DateAndOrgs.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
};

export default withStyles(styles)(DateAndOrgs);
